import { Button } from "@nextui-org/react";

import Link from "next/link";
import React from "react";

const HomeAppComponent = () => {
  return (
    <div className="lg:m-10">
      <div className="w-full max-w-[1720px] mx-auto  p-5 bg-[url(/apps/bg-gradient.svg)] bg-no-repeat bg-cover">
        <div className="flex flex-col-reverse lg:flex-row items-center justify-between container mx-auto">
          <div className="relative">
            <h1 className="font-semibold text-xl mt-3 mb-1 lg:mt-6 lg:mb-3 text-center lg:text-start">
              با اپلیکیشن های منه باخ
            </h1>
            <h1 className="text-lg mb-3 text-zinc-200">
              در هر جا محتوای مورد علاقه خود را به راحتی تماشا کنید
            </h1>
            <Link href="/apps">
              <Button
                className="text-[rgba(21,21,21,1)] bg-white text-sm w-full lg:max-w-56 my-5"
                startContent={
                  <img
                    width={20}
                    height={20}
                    src={"/apps/dnl-icon.svg"}
                    alt="download"
                  />
                }
                key="download"
                size="md"
              >
                دانلود اپلیکیشن های منه باخ
              </Button>
            </Link>
          </div>
          <img src={"/apps/main-pic.png"} width={653} height={475} alt="" />
        </div>
      </div>
    </div>
  );
};

export default HomeAppComponent;
